module.exports = __webpack_public_path__ + "static/media/joomla.bd319452.svg";